module.exports = __webpack_public_path__ + "img/interbank.1a116f3f.jpg";